
// gets or generates a german ISO string for backend compatibility
export const getGermanIsoString = (date: Date|null = null): string => {
    const dateToGermanize = date ?? new Date();
    return dateToGermanize.toLocaleString('sv-SE', { timeZone: 'Europe/Berlin' }).replace(' ', 'T');
}